// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Axios
import axios from 'axios';

// AntD Mobile
import { Picker } from 'antd-mobile'

// Quill
import ReactQuill, { Quill } from 'react-quill';
import '../style/bubble.css'; // Стандартная тема Quill

// Telegram UI
import { AppRoot, ButtonCell, Button, Cell, Chip, IconContainer, Multiselectable, Select, Section, Slider, Spinner, Navigation, Textarea, Switch, Radio } from '@telegram-apps/telegram-ui';

// VK UI & Icons
import { Snackbar, IconButton } from '@vkontakte/vkui';
import { Icon20TextBoldOutline, Icon20TextItalicOutline, Icon20ClockOutline, Icon28ErrorCircleOutline } from '@vkontakte/icons';

// Icons
import { ReactComponent as TempIcon } from "../assets/temp.svg";
import { ReactComponent as TempLowIcon } from "../assets/temp_low.svg";
import { ReactComponent as UnlinkIcon } from "../assets/unlink.svg";
import { ReactComponent as OtherIcon } from "../assets/other.svg";
import { ReactComponent as PromptsIcon } from "../assets/prompts.svg";
import { ReactComponent as TestIcon } from "../assets/test.svg";
import { ReactComponent as DigestIcon } from "../assets/digest.svg";

// Lottie
import Lottie from 'react-lottie';
import generatingPost from '../lotties/magic_wand.json';

// Motion
import { motion } from 'framer-motion';

const tg = window.Telegram.WebApp;

const DigestPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, setSelectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [prompt, setPrompt] = useState(stream.prompt)
    const [temp, setTemp] = useState(stream.temp)
    const [promptLibrary, setPromptLibrary] = useState(null);
    const [sign, setSign] = useState(stream.sign);
    const [digest, setDigest] = useState(stream.digest);
    const [digestNews, setDigestNews] = useState(stream.digest_news);
    const [digestTime, setDigestTime] = useState(stream.digest_timer);
    const [digestLang, setDigestLang] = useState(stream.digest_lang || 'ru');
    const [timeVisible, setTimeVisible] = useState(false);
    const promptRef = useRef(null);
    const signRef = useRef(null);

    const [showLoader, setShowLoader] = useState(false);

    const generateTimeOptions = (start, end, suffix = '') => {
        const options = [];
        for (let i = start; i <= end; i++) {
            const label = i.toString().padStart(2, '0');
            options.push({ label, value: label + suffix });
        }
        return options;
    };

    const basicColumns = [
        generateTimeOptions(0, 23),
        [':'],
        generateTimeOptions(0, 59),
    ];

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'digest') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        if (promptRef.current) {
            promptRef.current.style.height = 'auto';
            promptRef.current.style.height = `${promptRef.current.scrollHeight}px`;
        }
        console.log(stream)
    }, [prompt]);


    useEffect(() => {
        const saveStyle = async () => {
            const url = 'https://api.gmpapp.ru/save_style';

            const updatedStreamObj = {
                ...stream,
                prompt: prompt,
                sign: sign,
                digest: digest,
                digest_timer: digestTime,
                digest_news: digestNews,
                digest_lang: digestLang,
                temp: temp
            };

            setStream(updatedStreamObj);

            if (setSelectedGroup && selectedGroup) {
                setSelectedGroup(prevGroup => {
                    if (!prevGroup) return prevGroup;
                    const newStreams = [...prevGroup.streams];
                    const streamIdx = newStreams.findIndex(s => s.id === stream.id);
                    if (streamIdx !== -1) {
                        newStreams[streamIdx] = updatedStreamObj;
                    }
                    return { ...prevGroup, streams: newStreams };
                });
            }

            console.log(selectedGroup.id, stream.id, temp, prompt, sign, stream.promptLibrary)

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        group_id: selectedGroup.id,
                        stream_id: stream.id,
                        temp: temp,
                        prompt: prompt,
                        sign: sign,
                        digest: digest,
                        digest_timer: digestTime,
                        digest_news: digestNews,
                        digest_lang: digestLang,
                        promptLibrary: stream.promptLibrary
                    }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    tg.BackButton.show();
                    setShowLoader(false);
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    tg.BackButton.show();
                    setShowLoader(false);
                    const data = await response.json();
                    console.log('Success:', data);
                }
            } catch (error) {
                tg.BackButton.show();
                setShowLoader(false);
                console.error('Error streams sending', error);
            }
        };

        tg.BackButton.hide();
        setShowLoader(true);
        saveStyle();
    }, [temp, prompt, sign, digest, digestNews, digestTime, digestLang]);

    const handleContextMenu = (event) => {
        event.preventDefault();
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Picker
                    cancelText="Отменить"
                    confirmText="Изменить"
                    mouseWheel={true}
                    columns={basicColumns}
                    visible={timeVisible}
                    onClose={() => {
                        setTimeVisible(false)
                    }}
                    onConfirm={v => {
                        const timeString = `${v[0]}:${v[2]}`;
                        setDigestTime(timeString);
                        setTimeVisible(false);
                    }}
                />
                <Section className='sectionChannelStyle' header='Дайджест' footer='Режим дайджеста собирает все подходящие новости из указанных источников на основе ключевых и стоп-слов, фильтрует их и формирует единый сводный пост'>
                    <Cell
                        Component="label"
                        className="settingsItem"
                        before={<DigestIcon className='SettingsItemIcon' />}
                        after={
                            <Switch
                                className='postingSwitch'
                                onChange={(event) => setDigest(event.target.checked)}
                                checked={digest}
                            />
                        }
                        multiline
                    >
                        Режим дайджеста
                    </Cell>
                </Section>
                <Section className='sectionChannelStyle' header='Время дайджеста' footer='Данная настройка устанавливает время публикации поста-дайджеста'>
                    <Cell Component="label" after={<Button className="addChannel"
                        before={<Icon20ClockOutline />}
                        onClick={() => { setTimeVisible(true) }}
                        style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal }}
                        size='s'
                        stretched
                    >
                        Изменить
                    </Button>}>{digestTime}</Cell>
                </Section>
                <Section className='sectionChannelStyle' header="Язык дайджеста" footer="Выберите язык, на котором будет формироваться ваш дайджест">
                    <Cell
                        Component="label"
                        after={<Radio checked={digestLang === 'ru'} onChange={() => setDigestLang('ru')} name="digestLang" value="ru" />}
                    >
                        Русский
                    </Cell>
                    <Cell
                        Component="label"
                        after={<Radio checked={digestLang === 'en'} onChange={() => setDigestLang('en')} name="digestLang" value="en" />}
                    >
                        English
                    </Cell>
                </Section>
                <Section className='sectionChannelStyle tempStyle' header="Количество новостей" footer="Ползунок «Количество новостей» регулирует, сколько главный новостей будет опубликовано в посте-дайджесте">
                    <Slider step={1} min={5} max={10} defaultValue={digestNews} onChange={e => setDigestNews(e)} after={digestNews} />
                </Section>
                {showLoader && (
                    <Spinner className="saveLoader" size="m" />
                )}
            </AppRoot>
        </div>
    );
};

export default DigestPage;